"use client";
import { useEffect } from "react";

type LifecycleCallbacks = {
  onMount?: () => void | (() => void);
  onUnmount?: () => void;
};

/**
 * A hook that provides component lifecycle methods similar to class components
 * @param callbacks - Object containing lifecycle callback functions
 * @param callbacks.onMount - Function to be called when component mounts
 * @param callbacks.onUnmount - Function to be called when component unmounts
 */
export const useComponentLifecycle = ({ onMount, onUnmount }: LifecycleCallbacks): void => {
  useEffect(() => {
    // Handle mount
    const cleanup = onMount?.();

    // Handle unmount
    return () => {
      if (typeof cleanup === "function") {
        cleanup();
      }
      onUnmount?.();
    };
  }, []); // Empty dependency array ensures this runs only on mount/unmount
};
